import swiper from "swiper";

if ($(".js-slider-nav").length) {
  var itemsNav = new swiper(".js-slider-nav", {
    slidesPerView: 2.5,
    visibilityFullFit: true,
    spaceBetween: 10,
    centeredSlides: true,
    slidesOffsetBefore: -40,
    slideToClickedSlide: true,
    watchOverflow: true,
    navigation: {
      nextEl: ".-next",
      prevEl: ".-prev",
    },

    // slidesPerView: 'auto',
    // visibilityFullFit: true,
    // spaceBetween: 0,
    // centeredSlides: true,
    // slidesOffsetBefore: -120,
    // slideToClickedSlide: true,
    // watchOverflow: true
  });

  var itemsMain = new swiper(".js-slider-main", {
    visibilityFullFit: true,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    slideToClickedSlide: true,
  });

  itemsMain.controller.control = itemsNav;
  itemsNav.controller.control = itemsMain;
}

//商品詳細のメイン画像
if ($(".js-slider-navImage").length) {
  var navImages = new swiper(".js-slider-navImage", {
    slidesPerView: 4,
    visibilityFullFit: true,
    spaceBetween: 10,
    centeredSlides: true,
    slidesOffsetBefore: -115,
    slideToClickedSlide: true,
    watchOverflow: true,
    navigation: {
      nextEl: ".-next",
      prevEl: ".-prev",
    },
    breakpoints: {
      // 画面幅が 640px 以上の場合（window width >= 640px）
      599: {
        slidesOffsetBefore: -85,
      },
    },
    // slidesPerView: 'auto',
    // visibilityFullFit: true,
    // spaceBetween: 0,
    // centeredSlides: true,
    // slidesOffsetBefore: -120,
    // slideToClickedSlide: true,
    // watchOverflow: true
  });

  var mainImages = new swiper(".js-slider-mainImage", {
    visibilityFullFit: true,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    slideToClickedSlide: true,
  });

  mainImages.controller.control = navImages;
  navImages.controller.control = mainImages;
}

